import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { ButtonSharedModule, ModalSharedModule } from "pf_styleguide";
import { BookingDetailsModule } from "../../../venue/checkout/partials/booking-details/booking-details.module";
import { CheckoutPopupComponent } from "./checkout-popup.component";
import { SplitpayBookingDetailsModule } from "app/venue/checkout/partials/splitpay-booking-details/splitpay-booking-details.module";

@NgModule({
    imports: [
        CommonModule,
        ModalSharedModule,
        ButtonSharedModule,
        RouterModule,

        BookingDetailsModule,
        SplitpayBookingDetailsModule
    ],
    exports: [CheckoutPopupComponent],
    declarations: [CheckoutPopupComponent],
})
export class CheckoutPopupModule {}
